
export default {
    name: 'nominateStudentList',
    title: '推荐学生列表',
    component: () => import('../../../views/dialog/nominateStudentList')
}
